import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { flashlightLengths, flashlightColors } from '../../../Config/constants';
import { FormControl, FormHelperText } from '@material-ui/core';

export default function EditRushOrderDialog(props) {

    const classes = useStyles();
    const [color, setColor] = useState(null)
    const [coverColor, setCoverColor] = useState(null)
    const [bodyColor, setBodyColor] = useState(null)
    const [lensColor, setLensColor] = useState(null)
    const [body, setBody] = useState(null)

    useEffect(() => {
        setCoverColor(JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].CoverColor)
        setBodyColor(JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].BodyColor)
        setLensColor(JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].LensColor)
        setBody(JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].Body)

    }, [props.dialogValue])

    let isColor = props.dialogValue === "Colour"
    let isBody = props.dialogValue === "Body"

    const changeRushOrder = () => {
        if (isColor) {
            props.changeRushOrder(props.dialogValue, coverColor, bodyColor, lensColor)
        }
        else {
            props.changeRushOrder(props.dialogValue, body, "", "")
        }

        props.closeDialog()
    }

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            aria-labelledby="draggable-dialog-title"
            onClose={props.closeDialog}
        >
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {"Edit " + props.dialogValue}
            </DialogTitle>
            {
                isBody && <FormControl size="small"><FormHelperText className={classes.selectText}>Body size</FormHelperText><Select
                    labelId="bodyselect"
                    id="bodyselect"
                    variant="outlined"
                    className={classes.select}
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                >
                    {
                        flashlightLengths.map(x =>
                            <MenuItem value={x} key={x}>{x}</MenuItem>
                        )
                    }
                </Select></FormControl>
            }
            {
                !isBody && <React.Fragment>
                    <FormControl size="small">
                        <FormHelperText className={classes.selectText}>Cover color</FormHelperText>
                        <Select
                            labelId="coverselect"
                            id="coverselect"
                            variant="outlined"
                            className={classes.select}
                            value={coverColor}
                            onChange={(e) => setCoverColor(e.target.value)}
                        >
                            {
                                flashlightColors.map(x =>
                                    <MenuItem value={x} key={x}>{x}</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                    <FormControl size="small">
                        <FormHelperText className={classes.selectText}>Body color</FormHelperText>
                        <Select
                            labelId="bodycolorselect"
                            id="bodycolorselect"
                            variant="outlined"
                            className={classes.select}
                            value={bodyColor}
                            onChange={(e) => setBodyColor(e.target.value)}
                        >
                            {
                                flashlightColors.map(x =>
                                    <MenuItem value={x} key={x}>{x}</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                    <FormControl size="small">
                        <FormHelperText className={classes.selectText}>Lens color</FormHelperText>
                        <Select
                            labelId="lenscolorselect"
                            id="lenscolorselect"
                            variant="outlined"
                            className={classes.select}
                            value={lensColor}
                            onChange={(e) => setLensColor(e.target.value)}
                        >
                            {
                                flashlightColors.map(x =>
                                    <MenuItem value={x} key={x}>{x}</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                </React.Fragment>
            }
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.okButton} autoFocus onClick={changeRushOrder}>
                        OK
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({

    dialogContainer: {
        minWidth: "400px !important",
        minHeight: "480px !important",
        margin: "auto"
    },
    buttons: {
        width: "520px",
        textAlign: "center"
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "50px",
        marginBottom: "20px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "20px",
        cursor: 'move',
    },
    select: {
        width: "150px",
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: "15px"
    },
    selectText: {
        width: "150px",
        marginLeft: "auto",
        marginRight: "auto",
    }
}));
